// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!/opt/devenv/allscs-jhh/repair-ui/~/vue-style-loader!/opt/devenv/allscs-jhh/repair-ui/~/css-loader?{"minimize":true,"sourceMap":true}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cb8ef4a","scoped":false,"hasInlineConfig":false}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/store/coupon/components/couponEdit.vue
// module id = 1276
// module chunks = 0